
















import { Prop, Watch } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import cookieMixin from '@/mixins/cookie';

@Component
export default class RadioButton extends mixins(cookieMixin) {
  @Prop() private id!: string;
  @Prop() private name!: string;
  @Prop() private value!: string;
  @Prop() private namespace!: string;
  @Prop() private state!: string;
  @Prop() private validateRules!: string;

  created() {
    this.radioStatus = this.findString(this.payload);
  }

  get payload() {
    return { id: this.name };
  }

  get radioStatus() {
    return this.$store.getters[`${this.namespace}/${this.state}`];
  }
  set radioStatus(value: any) {
    this.$store.commit(`${this.namespace}/${this.state}`, value);
  }

  private saveStatus(): void {
    this.saveValue(this.payload, this.value);
  }
}
